import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { ErrorFallback } from 'components/ErrorFallback';
import { useSciDomain } from 'components/SciDomainContext';
import { PageLayoutViewProps } from 'types';

export const SqPageLayoutView = ({ handleError }: PageLayoutViewProps) => {
  const { data: { title } = {}, isLoading, isError } = useSciDomain();

  if (isLoading && !isError) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-w-screen tw-h-screen tw-bg-layout sm:tw-p-10">
      <title>{title}</title>

      <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
        <Outlet />
      </ErrorBoundary>
    </div>
  );
};
